/* global window:false */
/* eslint-env es6 */
/* eslint-disable global-require,import/no-extraneous-dependencies */

import inDOM from 'dom-helpers/util/inDOM';
import 'array.findindex';

if (process.env.NODE_ENV === 'development') {
  // In development, JSS classnames rely on Function.prototype.name, which is not available on IE11.
  // Without a polyfill, JSS doesn’t hydrate on IE11
  require('function.name-polyfill');
}

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

if (typeof Array.prototype.find !== 'function') {
  // [].find() is not present on IE11. Save some bytes by implementing in terms of findIndex (which
  // is polyfilled above) instead of importing 'array.find' separately.
  // eslint-disable-next-line no-extend-native,func-names
  Array.prototype.find = function (predicate, thisArg) {
    return this[this.findIndex(predicate, thisArg)];
  };
}

if (typeof Object.values !== 'function') {
  /* eslint-disable func-names,prefer-arrow-callback */
  // Object.values() is missing on IE11, but available polyfills are more fancy than we need. This
  // simple implementation (adapted from https://github.com/sindresorhus/object-values) will do.
  Object.values = function (object) {
    return Object.keys(object).map(function (key) {
      return object[key];
    });
  };
}

if (typeof Object.entries !== 'function') {
  // Object.entries() is missing on IE11,
  Object.entries = function (object) {
    return Object.keys(object).map(function (key) {
      return [key, object[key]];
    });
  };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  /* eslint-disable no-extend-native, object-shorthand, no-bitwise, no-plusplus */
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (valueToFind, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      const o = Object(this);
      const len = o.length >>> 0;

      if (len === 0) {
        return false;
      }

      const n = fromIndex | 0;
      let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        /* eslint-disable no-restricted-globals */
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      while (k < len) {
        if (sameValueZero(o[k], valueToFind)) {
          return true;
        }
        k++;
      }
      return false;
    },
  });
}

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function (search, rawPos) {
      const pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    },
  });
}

if (inDOM) {
  // if lazysizes initializes itself immediately, it will alter the SSR markup before React
  // has a chance to mount, which will break hydration. So, we manually initialize lazysizes
  // in src/index.js
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.init = false;
  require('lazysizes/plugins/attrchange/ls.attrchange');
  require('lazysizes/plugins/respimg/ls.respimg');
  require('lazysizes/plugins/object-fit/ls.object-fit');
  require('lazysizes');
}
